import { useNavigate } from "react-router-dom";
import authUtil from './auth_util';
import React from "react";


function AuthHelper() {
    const navigate = useNavigate();

    const checkAuth = values => {
        // const token = localStorage.getItem('auth-token');
        const token = authUtil.getCredentials('auth-token');
        if(!token) {
            navigate('/seller/request-otp-to-login')
        }
    }

    React.useEffect(() => {
        checkAuth()
      }, []);
    
    return ''

}

function NavigateTo(navigate_link) {
    const navigate = useNavigate();
    navigate(navigate_link)
    return ''
}


export { AuthHelper,  NavigateTo};